import { Component } from "@angular/core";

@Component({
    selector: "query-auto-builder",
    templateUrl: "./query-auto-builder.component.html",
    styleUrls: ["query-auto-builder.component.scss"]
})
export class QueryAutoBuilderComponent {
}